import { createContext, useContext } from 'react';
import { StoreApi, create, useStore } from 'zustand';

export interface PreferenceInfo {
  bbbMode: boolean;
  setBbbMode: (val: boolean) => void;
  regionIdToView?: string;
  setRegionIdToView: (newId?: string) => void;
}

export const PreferenceContext = createContext<StoreApi<PreferenceInfo>>(
  create<PreferenceInfo>(() => ({
    bbbMode: false,
    setBbbMode: () => {},
    setRegionIdToView: () => {}
  }))
);

function usePreferenceService<U>(selector: (store: PreferenceInfo) => U): U {
  const context = useContext(PreferenceContext);
  if (!context) {
    throw new Error('usePreferenceService must be used within a PreferenceProvider');
  }
  return useStore(context, selector);
}

export const useBbbMode = () => {
  const bbbMode = usePreferenceService(state => state.bbbMode);
  const setBbbMode = usePreferenceService(state => state.setBbbMode);

  return { bbbMode, setBbbMode };
};

export const useRegionFilter = () => {
  const regionId = usePreferenceService(state => state.regionIdToView);
  const setRegionId = usePreferenceService(state => state.setRegionIdToView);

  return { regionId, setRegionId };
}